import React from "react";
import { DataBox } from "./DataBox";

export function BaseThreeTestItem() {
    return (
        <>
            <DataBox />
        </>
    )
}
